<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Mark Job Complete'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>

      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              formControlName="price"
              [label]="'Job price'"
              [form]="form.controls.price"
              [icon]="'assets/svg/cash.svg'"
              [errorMessage]="'Please select a rate.'"
              [submitted]="submitted"
              inputMode="numeric"
              [mask]="'currencyMask'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/time.svg'"
              [label]="'Job duration'"
              [form]="form.controls.duration"
              formControlName="duration"
              [items]="serviceDurationItems"
              [errorMessage]="'Please select a duration.'"
              [submitted]="submitted" />
          </tidy-row>
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Mark as Complete'"
          [action]="boundMarkComplete"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
